import React from "react";
import * as S from "./index-styled";
import PT from "prop-types";
import AchievesList from "_c/modules/profile/common/achieves-list";

const Achieves = ({ isOwner, achieves, t }) => {
  return (
    <S.Sect>
      <S.Title>{t("common:achieves")}</S.Title>
      <AchievesList
        t={t}
        achieves={achieves}
        isOwner={isOwner}
        pageType="client"
      />
    </S.Sect>
  );
};
Achieves.propTypes = {
  achieves: PT.array,
  isOwner: PT.bool,

  t: PT.func.isRequired,
};
export default Achieves;
